import deviceLocalClient from 'shared/api/device';

export async function getCardFromReader() {
  const res = await deviceLocalClient.get<any>('/get-card');
  return res?.data;
}
